export default __webpack_public_path__ + "static/media/cart-filled.b66f1b34.svg";